(function (Drupal, once) {
  Drupal.behaviors.infiniteImageSlider = {
    attach(context) {
      const sliders = once('infinite-slider-init', '#infinite-slider', context);

      if (sliders.length) {
        const slider = sliders[0];
        const wrapper = slider.parentElement;
        const speed = 0.3;
        let offset = 0;

        const slides = Array.from(slider.children);
        let sliderWidth = slider.scrollWidth;
        const wrapperWidth = wrapper.offsetWidth;

        while (sliderWidth < wrapperWidth * 2) {
          slides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            slider.appendChild(clone);
          });
          sliderWidth = slider.scrollWidth;
        }

        function step() {
          offset -= speed;
          slider.style.transform = `translateX(${offset}px)`;

          const firstSlide = slider.children[0];
          const slideWidth = firstSlide.offsetWidth + parseInt(getComputedStyle(slider).gap || 0);

          if (Math.abs(offset) >= slideWidth) {
            slider.appendChild(firstSlide);
            offset += slideWidth;
            slider.style.transform = `translateX(${offset}px)`;
          }

          requestAnimationFrame(step);
        }

        step();
      }

      // Caption rotation logic
      const captions = once('nerivio-caption-init', '.nerivio-image-slider-with-caption__caption', context);

      if (captions.length) {
        let currentIndex = 0;
        const container = document.querySelector('.nerivio-image-slider-with-caption__caption-container');

        function calculateAndSetContainerHeight() {
          if (!container) return;

          let maxHeight = 0;

          captions.forEach((el) => {
            const originalStyle = el.getAttribute('style') || '';
            el.style.position = 'static';
            el.style.opacity = '1';
            el.style.pointerEvents = 'auto';
            el.style.display = 'block';

            const height = el.offsetHeight;
            if (height > maxHeight) maxHeight = height;

            el.setAttribute('style', originalStyle);
          });

          container.style.minHeight = maxHeight + 'px';
        }

        function showCaption(index) {
          captions.forEach((el, i) => {
            el.classList.toggle('nerivio-image-slider-with-caption__caption--visible', i === index);
          });
        }

        showCaption(currentIndex);
        calculateAndSetContainerHeight();

        if (captions.length > 1) {
          setInterval(() => {
            currentIndex = (currentIndex + 1) % captions.length;
            showCaption(currentIndex);
          }, 5000);
        }

        window.addEventListener('resize', calculateAndSetContainerHeight);
      }
    }
  };
})(Drupal, once);
